import { NonNullableStringParameter, useAssignQueryParameter } from '@pba/react-router';
import type { ComponentProps } from 'react';
import { useEffect } from 'react';
import { useLogout } from 'common/services/hooks';
import CommunityLayout from './CommunityLayout';

type P = ComponentProps<typeof CommunityLayout>;

const CommunityLayoutWithGuard = (props: P) => {
  const logout = useLogout();

  // TODO: This should not be in feature but in page ideally
  const { value: changeRequestId } = useAssignQueryParameter('chr', NonNullableStringParameter);

  useEffect(() => {
    if (changeRequestId) {
      void (async () => {
        await logout();
      })();
    }
  }, [changeRequestId, logout]);

  if (changeRequestId) {
    return null;
  }

  return <CommunityLayout {...props} />;
};

export default CommunityLayoutWithGuard;
